import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Col, Input, Row } from "antd";
import AWS from "aws-sdk";

import Swal from "sweetalert2";

import commentApi from "../../../apis/Comment.api";
import { toastAlert } from "../../AlertComponent";

import CommentImagePreviewGroup from "./CommentImagePreviewGroup";
import CommentImageUpload from "./CommentImageUpload";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const CommentReplyRegister = ({
	comment,
	index,
	replyShow,
	replyShowId,
	getCommentList,
	getFindComment,
	findComment,
	comLoading,
	setComLoading,
}) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const [replyObj, setReplyObj] = useState({
		content: "",
		phone: "",
		phone_valid: "",
		password: "",
		password_valid: "",
		is_secret: false,
	});

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);
	const [biggestTitle, setBiggestTitle] = useState(0);

	useEffect(() => {
		// 답글 이미지 리스트
		if (comment?.replyDTOList?.imageList?.length > 0) {
			// 타이틀 중 가장 큰 값 저장
			let bigTitle =
				comment?.replyDTOList?.imageList
					?.reduce((prev, value) => {
						return prev?.title?.split("-")?.[1] >= value?.title?.split("-")?.[1]
							? prev
							: value;
					})
					?.title?.split("-")?.[1] ?? 0;
			setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

			let list = [];
			let photos = [];
			for (let i = 0; i < comment?.replyDTOList?.imageList?.length; i++) {
				let resultImageList = comment?.replyDTOList?.imageList[i];
				let source = `${process.env.REACT_APP_S3_HOST}/image/together/reply/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
				list.push(source);
				photos.push({
					title: resultImageList?.title,
					source: source,
					type: `image/${resultImageList?.img_type}`,
				});
			}
			// 최대 1개까지
			setImageList(list.slice(0, 1));
			setPhotoList(photos.slice(0, 1));
		} else {
			setImageList([]);
			setPhotoList([]);
		}
	}, [comment]);

	/**
	 * 댓글 작성 valid control
	 * @param e
	 */
	const handleComment = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		// 휴대폰 번호 밸리데이션
		if (name === "phone" || name === "phone_valid") {
			if (value?.length <= 11) {
				setReplyObj({
					...replyObj,
					[name]: phone,
				});
			}
		} else {
			setReplyObj({
				...replyObj,
				[name]: value,
			});
		}
	};

	/**
	 * 초기화
	 */
	const initializeComment = () => {
		setReplyObj({
			content: "",
			phone: "",
			phone_valid: "",
			password: "",
			password_valid: "",
			is_secret: false,
		});
		setImageList([]);
		setPhotoList([]);
	};

	/**
	 * 답글 등록
	 * @returns {Promise<void>}
	 */
	const submitReplyComment = async () => {
		if (cUser?.id) {
			if (replyObj.content?.trim()?.length) {
				const param = {
					comment_id: comment?.id,
					// phone: replyObj.phone,
					// password: replyObj.password,
					content: replyObj.content,
					is_secret: replyObj.is_secret,
					created_by: cUser?.id,
					is_influencer: !!cUser?.is_influencer,
					influencer_id: reduxChannel?.user_id,
				};
				setComLoading(true);
				const res = await commentApi.createReply(param);
				if (res.code === 200) {
					updateImageList(res.result);
				} else {
					setComLoading(false);
				}
			} else {
				toastAlert("답글을 작성해주세요.");
			}
		}
	};

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};
	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const updateImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			// 등록
			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
			// 수정
			else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			target_id: result?.id,
			target_type: "reply",
			created_by: cUser?.id,
			imageList: [...list],
		};
		const res = await commentApi.postCommentImage(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 등록되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				initializeComment();
				if (findComment) {
					getFindComment();
				} else {
					getCommentList();
				}
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("reply-image-list-error");
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/reply/${reduxChannel?.user_id}/${result?.id}-${
			biggestTitle + i + 1
		}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("reply-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("reply-s3-upload-error");
				setComLoading(false);
			});
		}
	};

	// const [commentShow, setCommentShow] = useState(false);
	return (
		<div
			className={`comment-reply-each`}
			id={`comment-reply-${index}`}
			style={
				replyShow
					? {
							display: "flex",
							// paddingTop: "0.5em",
							// paddingBottom: "2.5em"
					  }
					: {
							display: "none",
							// paddingTop: "0.5em",
							// paddingBottom: "2.5em"
					  }
			}
		>
			<img
				src={`/assets/images/channel/comment-reply.png`}
				alt={`댓글 프로필 이미지`}
				className={`comment-reply-img`}
				style={{ visibility: "hidden" }}
			/>
			<div
				className={`comment-register-div`}
				style={{ border: "none", padding: 0, width: "100%" }}
			>
				<Col>
					<div className={`comment-textarea-div`}>
						<Input.TextArea
							placeholder={`댓글을 남겨주세요.\nex) 오메가3 제품과 함께 먹으면 좋을 영양제 알려주세요`}
							value={replyObj?.content}
							name={`content`}
							onChange={handleComment}
							disabled={comLoading}
							// onFocus={() => setCommentShow(true)}
							// onBlur={() => setCommentShow(false)}
						/>
					</div>

					{/* 업로드한 이미지 보기 */}
					{!!imageList?.length && (
						<CommentImagePreviewGroup
							imageList={imageList}
							onDeleteImage={onDeleteImage}
							loading={comLoading}
						/>
					)}

					<Row
						className={`secret-button-group`}
						// style={commentShow ? {height: "auto", overflow: "hidden"} : {height: 0, overflow: "hidden"}}
					>
						{/* 댓글 이미지 업로드 */}
						<CommentImageUpload
							imageList={imageList}
							setImageList={setImageList}
							photoList={photoList}
							setPhotoList={setPhotoList}
						/>
						<div
							className={`secret-button-wrap`}
							onClick={() =>
								setReplyObj({
									...replyObj,
									is_secret: !replyObj.is_secret,
								})
							}
						>
							<img
								src={`/assets/images/login/check${
									replyObj.is_secret ? "-active" : ""
								}.png`}
								alt={`비밀글`}
								style={{
									height: "auto",
									width: "1.2em",
								}}
							/>
							{/*비밀글로 작성하기*/}
							비밀글
						</div>
						<Button onClick={submitReplyComment} disabled={comLoading}>
							댓글 달기
						</Button>
					</Row>
					<p
						style={{
							fontSize: "0.9em",
							color: "#6d7580",
							letterSpacing: "-0.5px",
						}}
					>
						* 이미지는 최대 1장까지 가능합니다.
					</p>
				</Col>

				{/* 휴대폰 번호/비밀번호 */}
				<>
					{/*<div className={`comment-information-div`}>*/}
					{/*    <div className={`comment-input-group`}>*/}
					{/*        <div className={`input-valid`}>*/}
					{/*            <Input*/}
					{/*                type={`text`}*/}
					{/*                placeholder={`휴대폰 번호 '-' 없이 입력해주세요.`}*/}
					{/*                value={replyObj?.phone}*/}
					{/*                name={`phone`}*/}
					{/*                onChange={handleComment}*/}
					{/*                pattern={`/d*`}*/}
					{/*                disabled={comLoading}*/}
					{/*            />*/}
					{/*        </div>*/}
					{/*        <div className={`input-valid`}>*/}
					{/*            <Input*/}
					{/*                type={`text`}*/}
					{/*                placeholder={`휴대폰 번호 확인`}*/}
					{/*                value={replyObj?.phone_valid}*/}
					{/*                name={`phone_valid`}*/}
					{/*                onChange={handleComment}*/}
					{/*                pattern={`/d*`}*/}
					{/*                disabled={comLoading}*/}
					{/*            />*/}
					{/*            {(!!replyObj?.phone_valid?.length && replyObj?.phone_valid !== replyObj.phone)*/}
					{/*                && (*/}
					{/*                    <p className={`caution`}>*/}
					{/*                        *휴대폰 번호를 확인해주세요*/}
					{/*                    </p>*/}
					{/*                )}*/}
					{/*        </div>*/}
					{/*        <div className={`input-valid`}>*/}
					{/*            <Input*/}
					{/*                type={`password`}*/}
					{/*                placeholder={`비밀번호`}*/}
					{/*                value={replyObj?.password}*/}
					{/*                name={`password`}*/}
					{/*                onChange={handleComment}*/}
					{/*                disabled={comLoading}*/}
					{/*            />*/}
					{/*        </div>*/}
					{/*        <div className={`input-valid`}>*/}
					{/*            <Input*/}
					{/*                type={`password`}*/}
					{/*                placeholder={`비밀번호 확인`}*/}
					{/*                value={replyObj?.password_valid}*/}
					{/*                name={`password_valid`}*/}
					{/*                onChange={handleComment}*/}
					{/*                disabled={comLoading}*/}
					{/*            />*/}
					{/*            {(!!replyObj?.password_valid?.length && replyObj?.password_valid !== replyObj.password)*/}
					{/*                && (*/}
					{/*                    <p className={`caution`}>*/}
					{/*                        *비밀번호를 확인해주세요*/}
					{/*                    </p>*/}
					{/*                )}*/}
					{/*        </div>*/}
					{/*    </div>*/}
					{/*    <p>* 휴대폰 번호는 댓글 등록/수정/삭제 시 필요합니다.</p>*/}
					{/*</div>*/}
				</>
			</div>
		</div>
	);
};
export default CommentReplyRegister;
